import { DeleteOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { useState } from "react";
import Client from "../../redux/models/client";

export const DeleteAttachmentButton = ({ item, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const deleteAttachment = async () => {
    try {
      setLoading(true);
      await Client.deleteAttachement(item.id);
      await Client.deleteFileFromS3(item.attachment);
      message.success("Attachment Deleted Successfully");
      onSuccess();
    } catch (error) {
      console.log(error);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button type="link" disabled={loading} onClick={() => deleteAttachment()}>
      <DeleteOutlined style={{ fontSize: 14, color: "red" }} />
    </Button>
  );
};
